export const TempratureWithoutAI = [
    {
        "x": 0,
        "y": 44
    },
    {
        "x": 0,
        "y": 44
    },
    {
        "x": 1,
        "y": 44
    },
    {
        "x": 2,
        "y": 44
    },
    {
        "x": 3,
        "y": 44
    },
    {
        "x": 4,
        "y": 44
    },
    {
        "x": 5,
        "y": 43
    },
    {
        "x": 6,
        "y": 44
    },
    {
        "x": 7,
        "y": 44
    },
    {
        "x": 8,
        "y": 44
    },
    {
        "x": 9,
        "y": 43
    },
    {
        "x": 10,
        "y": 44
    },
    {
        "x": 11,
        "y": 44
    },
    {
        "x": 12,
        "y": 45
    },
    {
        "x": 13,
        "y": 45
    },
    {
        "x": 14,
        "y": 45
    },
    {
        "x": 15,
        "y": 45
    },
    {
        "x": 16,
        "y": 46
    },
    {
        "x": 17,
        "y": 45
    },
    {
        "x": 18,
        "y": 46
    },
    {
        "x": 19,
        "y": 46
    },
    {
        "x": 20,
        "y": 47
    },
    {
        "x": 21,
        "y": 47
    },
    {
        "x": 22,
        "y": 47
    },
    {
        "x": 23,
        "y": 47
    },
    {
        "x": 24,
        "y": 47
    },
    {
        "x": 25,
        "y": 47
    },
    {
        "x": 26,
        "y": 48
    },
    {
        "x": 27,
        "y": 48
    },
    {
        "x": 28,
        "y": 48
    },
    {
        "x": 29,
        "y": 48
    },
    {
        "x": 30,
        "y": 49
    },
    {
        "x": 31,
        "y": 49
    },
    {
        "x": 32,
        "y": 49
    },
    {
        "x": 33,
        "y": 49
    },
    {
        "x": 34,
        "y": 50
    },
    {
        "x": 35,
        "y": 50
    },
    {
        "x": 36,
        "y": 50
    },
    {
        "x": 37,
        "y": 50
    },
    {
        "x": 38,
        "y": 50
    },
    {
        "x": 39,
        "y": 51
    },
    {
        "x": 41,
        "y": 51
    },
    {
        "x": 41,
        "y": 51
    },
    {
        "x": 43,
        "y": 52
    },
    {
        "x": 43,
        "y": 52
    },
    {
        "x": 45,
        "y": 53
    },
    {
        "x": 46,
        "y": 53
    },
    {
        "x": 47,
        "y": 54
    },
    {
        "x": 48,
        "y": 54
    },
    {
        "x": 49,
        "y": 54
    },
    {
        "x": 50,
        "y": 55
    },
    {
        "x": 51,
        "y": 54
    },
    {
        "x": 52,
        "y": 55
    },
    {
        "x": 53,
        "y": 56
    },
    {
        "x": 54,
        "y": 56
    },
    {
        "x": 55,
        "y": 57
    },
    {
        "x": 56,
        "y": 58
    },
    {
        "x": 57,
        "y": 58
    },
    {
        "x": 58,
        "y": 58
    },
    {
        "x": 59,
        "y": 58
    },
    {
        "x": 60,
        "y": 58
    },
    {
        "x": 61,
        "y": 59
    },
    {
        "x": 62,
        "y": 59
    },
    {
        "x": 63,
        "y": 60
    },
    {
        "x": 64,
        "y": 60
    },
    {
        "x": 65,
        "y": 60
    },
    {
        "x": 66,
        "y": 61
    },
    {
        "x": 67,
        "y": 61
    },
    {
        "x": 68,
        "y": 61
    },
    {
        "x": 69,
        "y": 62
    },
    {
        "x": 70,
        "y": 62
    },
    {
        "x": 71,
        "y": 62
    },
    {
        "x": 72,
        "y": 62
    },
    {
        "x": 73,
        "y": 63
    },
    {
        "x": 74,
        "y": 63
    },
    {
        "x": 75,
        "y": 64
    },
    {
        "x": 76,
        "y": 64
    },
    {
        "x": 77,
        "y": 62
    },
    {
        "x": 78,
        "y": 62
    },
    {
        "x": 79,
        "y": 62
    },
    {
        "x": 80,
        "y": 61
    },
    {
        "x": 81,
        "y": 62
    },
    {
        "x": 82,
        "y": 61
    },
    {
        "x": 83,
        "y": 60
    },
    {
        "x": 84,
        "y": 59
    },
    {
        "x": 85,
        "y": 58
    },
    {
        "x": 86,
        "y": 58
    },
    {
        "x": 87,
        "y": 57
    },
    {
        "x": 88,
        "y": 57
    },
    {
        "x": 89,
        "y": 56
    },
    {
        "x": 90,
        "y": 56
    },
    {
        "x": 91,
        "y": 55
    },
    {
        "x": 92,
        "y": 55
    },
    {
        "x": 93,
        "y": 54
    },
    {
        "x": 94,
        "y": 54
    },
    {
        "x": 95,
        "y": 54
    },
    {
        "x": 96,
        "y": 54
    },
    {
        "x": 97,
        "y": 54
    },
    {
        "x": 98,
        "y": 55
    },
    {
        "x": 99,
        "y": 55
    },
    {
        "x": 100,
        "y": 56
    },
    {
        "x": 101,
        "y": 56
    },
    {
        "x": 102,
        "y": 56
    },
    {
        "x": 103,
        "y": 56
    },
    {
        "x": 104,
        "y": 56
    },
    {
        "x": 105,
        "y": 57
    },
    {
        "x": 106,
        "y": 57
    },
    {
        "x": 107,
        "y": 57
    },
    {
        "x": 108,
        "y": 57
    },
    {
        "x": 109,
        "y": 58
    },
    {
        "x": 110,
        "y": 58
    },
    {
        "x": 112,
        "y": 58
    },
    {
        "x": 112,
        "y": 58
    },
    {
        "x": 114,
        "y": 58
    },
    {
        "x": 114,
        "y": 59
    },
    {
        "x": 116,
        "y": 60
    },
    {
        "x": 117,
        "y": 60
    },
    {
        "x": 118,
        "y": 60
    },
    {
        "x": 119,
        "y": 61
    },
    {
        "x": 120,
        "y": 62
    },
    {
        "x": 121,
        "y": 63
    },
    {
        "x": 122,
        "y": 64
    },
    {
        "x": 123,
        "y": 65
    },
    {
        "x": 124,
        "y": 66
    },
    {
        "x": 125,
        "y": 67
    },
    {
        "x": 126,
        "y": 68
    },
    {
        "x": 127,
        "y": 68
    },
    {
        "x": 128,
        "y": 69
    },
    {
        "x": 129,
        "y": 70
    },
    {
        "x": 130,
        "y": 71
    },
    {
        "x": 131,
        "y": 71
    },
    {
        "x": 132,
        "y": 72
    },
    {
        "x": 133,
        "y": 72
    },
    {
        "x": 134,
        "y": 72
    },
    {
        "x": 135,
        "y": 74
    },
    {
        "x": 136,
        "y": 74
    },
    {
        "x": 137,
        "y": 75
    },
    {
        "x": 138,
        "y": 75
    },
    {
        "x": 139,
        "y": 76
    },
    {
        "x": 140,
        "y": 76
    },
    {
        "x": 141,
        "y": 76
    },
    {
        "x": 142,
        "y": 77
    },
    {
        "x": 143,
        "y": 78
    },
    {
        "x": 144,
        "y": 78
    },
    {
        "x": 145,
        "y": 78
    },
    {
        "x": 146,
        "y": 79
    },
    {
        "x": 147,
        "y": 79
    },
    {
        "x": 148,
        "y": 79
    },
    {
        "x": 149,
        "y": 80
    },
    {
        "x": 150,
        "y": 80
    },
    {
        "x": 151,
        "y": 81
    },
    {
        "x": 152,
        "y": 82
    },
    {
        "x": 153,
        "y": 82
    },
    {
        "x": 154,
        "y": 82
    },
    {
        "x": 155,
        "y": 82
    },
    {
        "x": 156,
        "y": 83
    },
    {
        "x": 157,
        "y": 84
    },
    {
        "x": 158,
        "y": 85
    },
    {
        "x": 159,
        "y": 85
    },
    {
        "x": 160,
        "y": 84
    },
    {
        "x": 161,
        "y": 82
    },
    {
        "x": 162,
        "y": 82
    },
    {
        "x": 163,
        "y": 82
    },
    {
        "x": 164,
        "y": 83
    },
    {
        "x": 165,
        "y": 81
    },
    {
        "x": 166,
        "y": 80
    },
    {
        "x": 167,
        "y": 81
    },
    {
        "x": 168,
        "y": 83
    },
    {
        "x": 169,
        "y": 84
    },
    {
        "x": 170,
        "y": 84
    },
    {
        "x": 171,
        "y": 82
    },
    {
        "x": 172,
        "y": 80
    },
    {
        "x": 173,
        "y": 79
    },
    {
        "x": 174,
        "y": 79
    },
    {
        "x": 175,
        "y": 78
    },
    {
        "x": 176,
        "y": 77
    },
    {
        "x": 177,
        "y": 76
    },
    {
        "x": 178,
        "y": 76
    },
    {
        "x": 179,
        "y": 76
    },
    {
        "x": 180,
        "y": 76
    },
    {
        "x": 181,
        "y": 76
    },
    {
        "x": 182,
        "y": 78
    },
    {
        "x": 183,
        "y": 79
    },
    {
        "x": 185,
        "y": 80
    },
    {
        "x": 185,
        "y": 81
    },
    {
        "x": 187,
        "y": 82
    },
    {
        "x": 187,
        "y": 83
    },
    {
        "x": 189,
        "y": 84
    },
    {
        "x": 190,
        "y": 84
    },
    {
        "x": 191,
        "y": 85
    },
    {
        "x": 192,
        "y": 86
    },
    {
        "x": 193,
        "y": 87
    },
    {
        "x": 194,
        "y": 88
    },
    {
        "x": 195,
        "y": 89
    },
    {
        "x": 196,
        "y": 90
    },
    {
        "x": 197,
        "y": 91
    },
    {
        "x": 198,
        "y": 93
    },
    {
        "x": 199,
        "y": 94
    },
    {
        "x": 200,
        "y": 95
    },
    {
        "x": 201,
        "y": 97
    },
    {
        "x": 202,
        "y": 97
    },
    {
        "x": 203,
        "y": 98
    },
    {
        "x": 204,
        "y": 98
    },
    {
        "x": 205,
        "y": 100
    },
    {
        "x": 206,
        "y": 101
    },
    {
        "x": 207,
        "y": 101
    },
    {
        "x": 208,
        "y": 102
    },
    {
        "x": 209,
        "y": 104
    },
    {
        "x": 210,
        "y": 104
    },
    {
        "x": 211,
        "y": 104
    },
    {
        "x": 212,
        "y": 105
    },
    {
        "x": 213,
        "y": 106
    },
    {
        "x": 214,
        "y": 108
    },
    {
        "x": 215,
        "y": 108
    },
    {
        "x": 216,
        "y": 109
    },
    {
        "x": 217,
        "y": 110
    },
    {
        "x": 218,
        "y": 111
    },
    {
        "x": 219,
        "y": 112
    },
    {
        "x": 220,
        "y": 112
    },
    {
        "x": 221,
        "y": 113
    },
    {
        "x": 222,
        "y": 114
    },
    {
        "x": 223,
        "y": 114
    },
    {
        "x": 224,
        "y": 115
    },
    {
        "x": 225,
        "y": 115
    },
    {
        "x": 226,
        "y": 116
    },
    {
        "x": 227,
        "y": 117
    },
    {
        "x": 228,
        "y": 118
    },
    {
        "x": 229,
        "y": 118
    },
    {
        "x": 230,
        "y": 118
    },
    {
        "x": 231,
        "y": 119
    },
    {
        "x": 232,
        "y": 120
    },
    {
        "x": 233,
        "y": 120
    },
    {
        "x": 234,
        "y": 120
    },
    {
        "x": 235,
        "y": 121
    },
    {
        "x": 236,
        "y": 121
    },
    {
        "x": 237,
        "y": 122
    },
    {
        "x": 238,
        "y": 122
    },
    {
        "x": 239,
        "y": 123
    },
    {
        "x": 240,
        "y": 123
    },
    {
        "x": 241,
        "y": 124
    },
    {
        "x": 242,
        "y": 124
    },
    {
        "x": 243,
        "y": 125
    },
    {
        "x": 244,
        "y": 125
    },
    {
        "x": 245,
        "y": 125
    },
    {
        "x": 246,
        "y": 126
    },
    {
        "x": 247,
        "y": 126
    },
    {
        "x": 248,
        "y": 126
    },
    {
        "x": 249,
        "y": 127
    },
    {
        "x": 250,
        "y": 127
    },
    {
        "x": 251,
        "y": 128
    },
    {
        "x": 252,
        "y": 128
    },
    {
        "x": 253,
        "y": 129
    },
    {
        "x": 254,
        "y": 129
    },
    {
        "x": 255,
        "y": 129
    },
    {
        "x": 256,
        "y": 129
    },
    {
        "x": 258,
        "y": 130
    },
    {
        "x": 258,
        "y": 130
    },
    {
        "x": 260,
        "y": 130
    },
    {
        "x": 260,
        "y": 131
    },
    {
        "x": 262,
        "y": 131
    },
    {
        "x": 263,
        "y": 131
    },
    {
        "x": 264,
        "y": 132
    },
    {
        "x": 265,
        "y": 132
    },
    {
        "x": 266,
        "y": 132
    },
    {
        "x": 267,
        "y": 132
    },
    {
        "x": 268,
        "y": 132
    },
    {
        "x": 269,
        "y": 132
    },
    {
        "x": 270,
        "y": 133
    },
    {
        "x": 271,
        "y": 133
    },
    {
        "x": 272,
        "y": 133
    },
    {
        "x": 273,
        "y": 134
    },
    {
        "x": 274,
        "y": 133
    },
    {
        "x": 275,
        "y": 133
    },
    {
        "x": 276,
        "y": 133
    },
    {
        "x": 277,
        "y": 133
    },
    {
        "x": 278,
        "y": 133
    },
    {
        "x": 279,
        "y": 133
    },
    {
        "x": 280,
        "y": 133
    },
    {
        "x": 281,
        "y": 133
    },
    {
        "x": 282,
        "y": 134
    },
    {
        "x": 283,
        "y": 134
    },
    {
        "x": 284,
        "y": 134
    },
    {
        "x": 285,
        "y": 134
    },
    {
        "x": 286,
        "y": 134
    },
    {
        "x": 287,
        "y": 134
    },
    {
        "x": 288,
        "y": 134
    },
    {
        "x": 289,
        "y": 135
    },
    {
        "x": 290,
        "y": 135
    },
    {
        "x": 291,
        "y": 135
    },
    {
        "x": 292,
        "y": 135
    },
    {
        "x": 293,
        "y": 135
    },
    {
        "x": 294,
        "y": 135
    },
    {
        "x": 295,
        "y": 135
    },
    {
        "x": 296,
        "y": 135
    },
    {
        "x": 297,
        "y": 136
    },
    {
        "x": 298,
        "y": 136
    },
    {
        "x": 299,
        "y": 136
    },
    {
        "x": 300,
        "y": 137
    },
    {
        "x": 301,
        "y": 137
    },
    {
        "x": 302,
        "y": 137
    },
    {
        "x": 303,
        "y": 137
    },
    {
        "x": 304,
        "y": 137
    },
    {
        "x": 305,
        "y": 137
    },
    {
        "x": 306,
        "y": 137
    },
    {
        "x": 307,
        "y": 138
    },
    {
        "x": 308,
        "y": 138
    },
    {
        "x": 309,
        "y": 138
    },
    {
        "x": 310,
        "y": 138
    },
    {
        "x": 311,
        "y": 138
    },
    {
        "x": 312,
        "y": 138
    },
    {
        "x": 313,
        "y": 139
    },
    {
        "x": 314,
        "y": 139
    },
    {
        "x": 315,
        "y": 139
    },
    {
        "x": 316,
        "y": 139
    },
    {
        "x": 317,
        "y": 139
    },
    {
        "x": 318,
        "y": 139
    },
    {
        "x": 319,
        "y": 140
    },
    {
        "x": 320,
        "y": 140
    },
    {
        "x": 321,
        "y": 140
    },
    {
        "x": 322,
        "y": 140
    },
    {
        "x": 323,
        "y": 140
    },
    {
        "x": 324,
        "y": 140
    },
    {
        "x": 325,
        "y": 140
    },
    {
        "x": 326,
        "y": 140
    },
    {
        "x": 327,
        "y": 140
    },
    {
        "x": 329,
        "y": 141
    },
    {
        "x": 329,
        "y": 141
    },
    {
        "x": 331,
        "y": 141
    },
    {
        "x": 331,
        "y": 141
    },
    {
        "x": 333,
        "y": 141
    },
    {
        "x": 334,
        "y": 141
    },
    {
        "x": 335,
        "y": 141
    },
    {
        "x": 336,
        "y": 142
    },
    {
        "x": 337,
        "y": 142
    },
    {
        "x": 338,
        "y": 142
    },
    {
        "x": 339,
        "y": 142
    },
    {
        "x": 340,
        "y": 142
    },
    {
        "x": 341,
        "y": 142
    },
    {
        "x": 342,
        "y": 142
    },
    {
        "x": 343,
        "y": 142
    },
    {
        "x": 344,
        "y": 142
    },
    {
        "x": 345,
        "y": 142
    },
    {
        "x": 346,
        "y": 142
    },
    {
        "x": 347,
        "y": 143
    },
    {
        "x": 348,
        "y": 143
    },
    {
        "x": 349,
        "y": 143
    },
    {
        "x": 350,
        "y": 143
    },
    {
        "x": 351,
        "y": 143
    },
    {
        "x": 352,
        "y": 143
    },
    {
        "x": 353,
        "y": 143
    },
    {
        "x": 354,
        "y": 143
    },
    {
        "x": 355,
        "y": 143
    },
    {
        "x": 356,
        "y": 143
    },
    {
        "x": 357,
        "y": 143
    },
    {
        "x": 358,
        "y": 143
    },
    {
        "x": 359,
        "y": 143
    },
    {
        "x": 360,
        "y": 143
    },
    {
        "x": 361,
        "y": 143
    },
    {
        "x": 362,
        "y": 143
    },
    {
        "x": 363,
        "y": 144
    },
    {
        "x": 364,
        "y": 144
    },
    {
        "x": 365,
        "y": 144
    },
    {
        "x": 366,
        "y": 144
    },
    {
        "x": 367,
        "y": 144
    },
    {
        "x": 368,
        "y": 144
    },
    {
        "x": 369,
        "y": 144
    },
    {
        "x": 370,
        "y": 144
    },
    {
        "x": 371,
        "y": 144
    },
    {
        "x": 372,
        "y": 144
    },
    {
        "x": 373,
        "y": 144
    },
    {
        "x": 374,
        "y": 144
    },
    {
        "x": 375,
        "y": 144
    },
    {
        "x": 376,
        "y": 143
    },
    {
        "x": 377,
        "y": 140
    }
];

export const TempratureWithAI = [
    {
        "x": 0,
        "y": 140
    },
    {
        "x": 0,
        "y": 140
    },
    {
        "x": 1,
        "y": 140
    },
    {
        "x": 2,
        "y": 140
    },
    {
        "x": 3,
        "y": 140
    },
    {
        "x": 4,
        "y": 140
    },
    {
        "x": 5,
        "y": 140
    },
    {
        "x": 6,
        "y": 140
    },
    {
        "x": 7,
        "y": 140
    },
    {
        "x": 8,
        "y": 140
    },
    {
        "x": 9,
        "y": 140
    },
    {
        "x": 10,
        "y": 140
    },
    {
        "x": 11,
        "y": 140
    },
    {
        "x": 12,
        "y": 140
    },
    {
        "x": 13,
        "y": 140
    },
    {
        "x": 14,
        "y": 140
    },
    {
        "x": 15,
        "y": 140
    },
    {
        "x": 16,
        "y": 140
    },
    {
        "x": 17,
        "y": 140
    },
    {
        "x": 18,
        "y": 140
    },
    {
        "x": 19,
        "y": 140
    },
    {
        "x": 20,
        "y": 140
    },
    {
        "x": 21,
        "y": 140
    },
    {
        "x": 22,
        "y": 140
    },
    {
        "x": 23,
        "y": 140
    },
    {
        "x": 24,
        "y": 140
    },
    {
        "x": 25,
        "y": 140
    },
    {
        "x": 26,
        "y": 140
    },
    {
        "x": 27,
        "y": 140
    },
    {
        "x": 28,
        "y": 140
    },
    {
        "x": 29,
        "y": 140
    },
    {
        "x": 30,
        "y": 140
    },
    {
        "x": 31,
        "y": 140
    },
    {
        "x": 32,
        "y": 140
    },
    {
        "x": 33,
        "y": 140
    },
    {
        "x": 34,
        "y": 140
    },
    {
        "x": 35,
        "y": 140
    },
    {
        "x": 36,
        "y": 140
    },
    {
        "x": 37,
        "y": 140
    },
    {
        "x": 38,
        "y": 140
    },
    {
        "x": 39,
        "y": 140
    },
    {
        "x": 41,
        "y": 140
    },
    {
        "x": 41,
        "y": 140
    },
    {
        "x": 43,
        "y": 140
    },
    {
        "x": 43,
        "y": 140
    },
    {
        "x": 45,
        "y": 140
    },
    {
        "x": 46,
        "y": 140
    },
    {
        "x": 47,
        "y": 140
    },
    {
        "x": 48,
        "y": 140
    },
    {
        "x": 49,
        "y": 140
    },
    {
        "x": 50,
        "y": 140
    },
    {
        "x": 51,
        "y": 140
    },
    {
        "x": 52,
        "y": 140
    },
    {
        "x": 53,
        "y": 140
    },
    {
        "x": 54,
        "y": 140
    },
    {
        "x": 55,
        "y": 140
    },
    {
        "x": 56,
        "y": 140
    },
    {
        "x": 57,
        "y": 140
    },
    {
        "x": 58,
        "y": 140
    },
    {
        "x": 59,
        "y": 140
    },
    {
        "x": 60,
        "y": 140
    },
    {
        "x": 61,
        "y": 140
    },
    {
        "x": 62,
        "y": 140
    },
    {
        "x": 63,
        "y": 140
    },
    {
        "x": 64,
        "y": 140
    },
    {
        "x": 65,
        "y": 140
    },
    {
        "x": 66,
        "y": 140
    },
    {
        "x": 67,
        "y": 140
    },
    {
        "x": 68,
        "y": 140
    },
    {
        "x": 69,
        "y": 140
    },
    {
        "x": 70,
        "y": 140
    },
    {
        "x": 71,
        "y": 140
    },
    {
        "x": 72,
        "y": 140
    },
    {
        "x": 73,
        "y": 140
    },
    {
        "x": 74,
        "y": 140
    },
    {
        "x": 75,
        "y": 140
    },
    {
        "x": 76,
        "y": 140
    },
    {
        "x": 77,
        "y": 140
    },
    {
        "x": 78,
        "y": 140
    },
    {
        "x": 79,
        "y": 140
    },
    {
        "x": 80,
        "y": 140
    },
    {
        "x": 81,
        "y": 140
    },
    {
        "x": 82,
        "y": 140
    },
    {
        "x": 83,
        "y": 140
    },
    {
        "x": 84,
        "y": 140
    },
    {
        "x": 85,
        "y": 140
    },
    {
        "x": 86,
        "y": 140
    },
    {
        "x": 87,
        "y": 140
    },
    {
        "x": 88,
        "y": 140
    },
    {
        "x": 89,
        "y": 140
    },
    {
        "x": 90,
        "y": 140
    },
    {
        "x": 91,
        "y": 140
    },
    {
        "x": 92,
        "y": 140
    },
    {
        "x": 93,
        "y": 140
    },
    {
        "x": 94,
        "y": 140
    },
    {
        "x": 95,
        "y": 140
    },
    {
        "x": 96,
        "y": 140
    },
    {
        "x": 97,
        "y": 140
    },
    {
        "x": 98,
        "y": 140
    },
    {
        "x": 99,
        "y": 140
    },
    {
        "x": 100,
        "y": 140
    },
    {
        "x": 101,
        "y": 140
    },
    {
        "x": 102,
        "y": 140
    },
    {
        "x": 103,
        "y": 140
    },
    {
        "x": 104,
        "y": 140
    },
    {
        "x": 105,
        "y": 140
    },
    {
        "x": 106,
        "y": 140
    },
    {
        "x": 107,
        "y": 140
    },
    {
        "x": 108,
        "y": 140
    },
    {
        "x": 109,
        "y": 140
    },
    {
        "x": 110,
        "y": 140
    },
    {
        "x": 112,
        "y": 140
    },
    {
        "x": 112,
        "y": 140
    },
    {
        "x": 114,
        "y": 140
    },
    {
        "x": 114,
        "y": 140
    },
    {
        "x": 116,
        "y": 140
    },
    {
        "x": 117,
        "y": 140
    },
    {
        "x": 118,
        "y": 140
    },
    {
        "x": 119,
        "y": 140
    },
    {
        "x": 120,
        "y": 140
    },
    {
        "x": 121,
        "y": 140
    },
    {
        "x": 122,
        "y": 140
    },
    {
        "x": 123,
        "y": 140
    },
    {
        "x": 124,
        "y": 140
    },
    {
        "x": 125,
        "y": 140
    },
    {
        "x": 126,
        "y": 140
    },
    {
        "x": 127,
        "y": 140
    },
    {
        "x": 128,
        "y": 140
    },
    {
        "x": 129,
        "y": 140
    },
    {
        "x": 130,
        "y": 140
    },
    {
        "x": 131,
        "y": 140
    },
    {
        "x": 132,
        "y": 140
    },
    {
        "x": 133,
        "y": 140
    },
    {
        "x": 134,
        "y": 140
    },
    {
        "x": 135,
        "y": 140
    },
    {
        "x": 136,
        "y": 140
    },
    {
        "x": 137,
        "y": 140
    },
    {
        "x": 138,
        "y": 140
    },
    {
        "x": 139,
        "y": 140
    },
    {
        "x": 140,
        "y": 140
    },
    {
        "x": 141,
        "y": 140
    },
    {
        "x": 142,
        "y": 140
    },
    {
        "x": 143,
        "y": 140
    },
    {
        "x": 144,
        "y": 140
    },
    {
        "x": 145,
        "y": 140
    },
    {
        "x": 146,
        "y": 140
    },
    {
        "x": 147,
        "y": 140
    },
    {
        "x": 148,
        "y": 140
    },
    {
        "x": 149,
        "y": 140
    },
    {
        "x": 150,
        "y": 140
    },
    {
        "x": 151,
        "y": 140
    },
    {
        "x": 152,
        "y": 140
    },
    {
        "x": 153,
        "y": 140
    },
    {
        "x": 154,
        "y": 140
    },
    {
        "x": 155,
        "y": 140
    },
    {
        "x": 156,
        "y": 140
    },
    {
        "x": 157,
        "y": 140
    },
    {
        "x": 158,
        "y": 140
    },
    {
        "x": 159,
        "y": 140
    },
    {
        "x": 160,
        "y": 140
    },
    {
        "x": 161,
        "y": 140
    },
    {
        "x": 162,
        "y": 140
    },
    {
        "x": 163,
        "y": 140
    },
    {
        "x": 164,
        "y": 140
    },
    {
        "x": 165,
        "y": 140
    },
    {
        "x": 166,
        "y": 140
    },
    {
        "x": 167,
        "y": 140
    },
    {
        "x": 168,
        "y": 140
    },
    {
        "x": 169,
        "y": 140
    },
    {
        "x": 170,
        "y": 140
    },
    {
        "x": 171,
        "y": 140
    },
    {
        "x": 172,
        "y": 140
    },
    {
        "x": 173,
        "y": 140
    },
    {
        "x": 174,
        "y": 140
    },
    {
        "x": 175,
        "y": 140
    },
    {
        "x": 176,
        "y": 140
    },
    {
        "x": 177,
        "y": 140
    },
    {
        "x": 178,
        "y": 140
    },
    {
        "x": 179,
        "y": 140
    },
    {
        "x": 180,
        "y": 140
    },
    {
        "x": 181,
        "y": 140
    },
    {
        "x": 182,
        "y": 140
    },
    {
        "x": 183,
        "y": 140
    },
    {
        "x": 185,
        "y": 140
    },
    {
        "x": 185,
        "y": 140
    },
    {
        "x": 187,
        "y": 140
    },
    {
        "x": 187,
        "y": 140
    },
    {
        "x": 189,
        "y": 140
    },
    {
        "x": 190,
        "y": 140
    },
    {
        "x": 191,
        "y": 140
    },
    {
        "x": 192,
        "y": 140
    },
    {
        "x": 193,
        "y": 140
    },
    {
        "x": 194,
        "y": 140
    },
    {
        "x": 195,
        "y": 140
    },
    {
        "x": 196,
        "y": 140
    },
    {
        "x": 197,
        "y": 140
    },
    {
        "x": 198,
        "y": 140
    },
    {
        "x": 199,
        "y": 140
    },
    {
        "x": 200,
        "y": 140
    },
    {
        "x": 201,
        "y": 140
    },
    {
        "x": 202,
        "y": 140
    },
    {
        "x": 203,
        "y": 140
    },
    {
        "x": 204,
        "y": 140
    },
    {
        "x": 205,
        "y": 140
    },
    {
        "x": 206,
        "y": 140
    },
    {
        "x": 207,
        "y": 140
    },
    {
        "x": 208,
        "y": 140
    },
    {
        "x": 209,
        "y": 140
    },
    {
        "x": 210,
        "y": 140
    },
    {
        "x": 211,
        "y": 140
    },
    {
        "x": 212,
        "y": 140
    },
    {
        "x": 213,
        "y": 140
    },
    {
        "x": 214,
        "y": 140
    },
    {
        "x": 215,
        "y": 140
    },
    {
        "x": 216,
        "y": 140
    },
    {
        "x": 217,
        "y": 140
    },
    {
        "x": 218,
        "y": 140
    },
    {
        "x": 219,
        "y": 140
    },
    {
        "x": 220,
        "y": 140
    },
    {
        "x": 221,
        "y": 140
    },
    {
        "x": 222,
        "y": 140
    },
    {
        "x": 223,
        "y": 140
    },
    {
        "x": 224,
        "y": 140
    },
    {
        "x": 225,
        "y": 140
    },
    {
        "x": 226,
        "y": 140
    },
    {
        "x": 227,
        "y": 140
    },
    {
        "x": 228,
        "y": 140
    },
    {
        "x": 229,
        "y": 140
    },
    {
        "x": 230,
        "y": 140
    },
    {
        "x": 231,
        "y": 140
    },
    {
        "x": 232,
        "y": 140
    },
    {
        "x": 233,
        "y": 140
    },
    {
        "x": 234,
        "y": 140
    },
    {
        "x": 235,
        "y": 140
    },
    {
        "x": 236,
        "y": 140
    },
    {
        "x": 237,
        "y": 140
    },
    {
        "x": 238,
        "y": 140
    },
    {
        "x": 239,
        "y": 140
    },
    {
        "x": 240,
        "y": 140
    },
    {
        "x": 241,
        "y": 140
    },
    {
        "x": 242,
        "y": 140
    },
    {
        "x": 243,
        "y": 140
    },
    {
        "x": 244,
        "y": 140
    },
    {
        "x": 245,
        "y": 140
    },
    {
        "x": 246,
        "y": 140
    },
    {
        "x": 247,
        "y": 140
    },
    {
        "x": 248,
        "y": 140
    },
    {
        "x": 249,
        "y": 140
    },
    {
        "x": 250,
        "y": 140
    },
    {
        "x": 251,
        "y": 140
    },
    {
        "x": 252,
        "y": 140
    },
    {
        "x": 253,
        "y": 140
    },
    {
        "x": 254,
        "y": 140
    },
    {
        "x": 255,
        "y": 140
    },
    {
        "x": 256,
        "y": 140
    },
    {
        "x": 258,
        "y": 140
    },
    {
        "x": 258,
        "y": 140
    },
    {
        "x": 260,
        "y": 140
    },
    {
        "x": 260,
        "y": 140
    },
    {
        "x": 262,
        "y": 140
    },
    {
        "x": 263,
        "y": 140
    },
    {
        "x": 264,
        "y": 140
    },
    {
        "x": 265,
        "y": 140
    },
    {
        "x": 266,
        "y": 140
    },
    {
        "x": 267,
        "y": 140
    },
    {
        "x": 268,
        "y": 140
    },
    {
        "x": 269,
        "y": 140
    },
    {
        "x": 270,
        "y": 140
    },
    {
        "x": 271,
        "y": 140
    },
    {
        "x": 272,
        "y": 140
    },
    {
        "x": 273,
        "y": 140
    },
    {
        "x": 274,
        "y": 140
    },
    {
        "x": 275,
        "y": 140
    },
    {
        "x": 276,
        "y": 140
    },
    {
        "x": 277,
        "y": 140
    },
    {
        "x": 278,
        "y": 140
    },
    {
        "x": 279,
        "y": 140
    },
    {
        "x": 280,
        "y": 140
    },
    {
        "x": 281,
        "y": 140
    },
    {
        "x": 282,
        "y": 140
    },
    {
        "x": 283,
        "y": 140
    },
    {
        "x": 284,
        "y": 140
    },
    {
        "x": 285,
        "y": 140
    },
    {
        "x": 286,
        "y": 140
    },
    {
        "x": 287,
        "y": 140
    },
    {
        "x": 288,
        "y": 140
    },
    {
        "x": 289,
        "y": 140
    },
    {
        "x": 290,
        "y": 140
    },
    {
        "x": 291,
        "y": 140
    },
    {
        "x": 292,
        "y": 140
    },
    {
        "x": 293,
        "y": 140
    },
    {
        "x": 294,
        "y": 140
    },
    {
        "x": 295,
        "y": 140
    },
    {
        "x": 296,
        "y": 140
    },
    {
        "x": 297,
        "y": 140
    },
    {
        "x": 298,
        "y": 140
    },
    {
        "x": 299,
        "y": 140
    },
    {
        "x": 300,
        "y": 140
    },
    {
        "x": 301,
        "y": 140
    },
    {
        "x": 302,
        "y": 140
    },
    {
        "x": 303,
        "y": 140
    },
    {
        "x": 304,
        "y": 140
    },
    {
        "x": 305,
        "y": 140
    },
    {
        "x": 306,
        "y": 140
    },
    {
        "x": 307,
        "y": 140
    },
    {
        "x": 308,
        "y": 140
    },
    {
        "x": 309,
        "y": 140
    },
    {
        "x": 310,
        "y": 140
    },
    {
        "x": 311,
        "y": 140
    },
    {
        "x": 312,
        "y": 140
    },
    {
        "x": 313,
        "y": 140
    },
    {
        "x": 314,
        "y": 140
    },
    {
        "x": 315,
        "y": 140
    },
    {
        "x": 316,
        "y": 140
    },
    {
        "x": 317,
        "y": 140
    },
    {
        "x": 318,
        "y": 140
    },
    {
        "x": 319,
        "y": 140
    },
    {
        "x": 320,
        "y": 140
    },
    {
        "x": 321,
        "y": 140
    },
    {
        "x": 322,
        "y": 140
    },
    {
        "x": 323,
        "y": 140
    },
    {
        "x": 324,
        "y": 140
    },
    {
        "x": 325,
        "y": 140
    },
    {
        "x": 326,
        "y": 140
    },
    {
        "x": 327,
        "y": 140
    },
    {
        "x": 329,
        "y": 140
    },
    {
        "x": 329,
        "y": 140
    },
    {
        "x": 331,
        "y": 140
    },
    {
        "x": 331,
        "y": 140
    },
    {
        "x": 333,
        "y": 140
    },
    {
        "x": 334,
        "y": 140
    },
    {
        "x": 335,
        "y": 140
    },
    {
        "x": 336,
        "y": 140
    },
    {
        "x": 337,
        "y": 140
    },
    {
        "x": 338,
        "y": 140
    },
    {
        "x": 339,
        "y": 140
    },
    {
        "x": 340,
        "y": 140
    },
    {
        "x": 341,
        "y": 140
    },
    {
        "x": 342,
        "y": 140
    },
    {
        "x": 343,
        "y": 140
    },
    {
        "x": 344,
        "y": 140
    },
    {
        "x": 345,
        "y": 140
    },
    {
        "x": 346,
        "y": 140
    },
    {
        "x": 347,
        "y": 140
    },
    {
        "x": 348,
        "y": 140
    },
    {
        "x": 349,
        "y": 140
    },
    {
        "x": 350,
        "y": 140
    },
    {
        "x": 351,
        "y": 140
    },
    {
        "x": 352,
        "y": 140
    },
    {
        "x": 353,
        "y": 140
    },
    {
        "x": 354,
        "y": 140
    },
    {
        "x": 355,
        "y": 140
    },
    {
        "x": 356,
        "y": 140
    },
    {
        "x": 357,
        "y": 140
    },
    {
        "x": 358,
        "y": 140
    },
    {
        "x": 359,
        "y": 140
    },
    {
        "x": 360,
        "y": 140
    },
    {
        "x": 361,
        "y": 140
    },
    {
        "x": 362,
        "y": 140
    },
    {
        "x": 363,
        "y": 140
    },
    {
        "x": 364,
        "y": 140
    },
    {
        "x": 365,
        "y": 140
    },
    {
        "x": 366,
        "y": 140
    },
    {
        "x": 367,
        "y": 140
    },
    {
        "x": 368,
        "y": 140
    },
    {
        "x": 369,
        "y": 140
    },
    {
        "x": 370,
        "y": 140
    },
    {
        "x": 371,
        "y": 140
    },
    {
        "x": 372,
        "y": 140
    },
    {
        "x": 373,
        "y": 140
    },
    {
        "x": 374,
        "y": 140
    },
    {
        "x": 375,
        "y": 140
    },
    {
        "x": 376,
        "y": 140
    },
    {
        "x": 377,
        "y": 140
    }
];
